<template>
    <!-- TODO translate -->
    <TransitionFade>
        <button
            v-if="y > 0"
            class="scroll-to-top-button"
            type="button"
            @click="scrollToTop"
        >
            Back to top
        </button>
    </TransitionFade>
</template>

<script setup lang="ts">
import { getWindow } from '@/helpers/globals'
import { useWindowScroll } from '@vueuse/core'

import TransitionFade from '@/components/transitions/TransitionFade.vue'

const { y } = useWindowScroll()

const window = getWindow()

const scrollToTop = () => {
    if (!window) {
        return
    }

    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    })
}
</script>

<style lang="scss" scoped>
.scroll-to-top-button {
    letter-spacing: 0.05em;
    text-transform: uppercase;
    cursor: pointer;

    &::before {
        font-family: $icon-font;
        content: $icon-angle-up;
        font-weight: 600;
        margin-right: 5px;
        line-height: 15px;
    }
}
</style>
